<template>
    <div :class="css.container">
        <div :class="css.header" class="font-variable font-bold color-1">
            Chr {{ origin?.chromosome.name }}: {{ origin?.chromosome.start }} - {{ origin?.chromosome.end }}
        </div>
        <div :class="css.body" ref="container">
            <div ref="chromosome"></div>

            <div ref="body" :class="css.attachments">
                <div :class="css.name" class="font-variable font-bold color-1" v-if="origin?.attachments?.data?.length">
                    <div>{{ $t("NearbyGenes", { name: origin?.symbol }) }}：{{ origin?.attachments?.data?.length - 1 }}</div>
                    <ui-tooltip :class="css.tooltip" :content="$t('NearbyGenesDescript', { number: origin?.attachments?.data?.length - 1 })">
                        <ui-icon name="mark" />
                    </ui-tooltip>
                </div>

                <div :class="css.canvas">
                    <div ref="attachments"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
//* 组件库
import { UiIcon, UiTooltip } from "various-ui";
//* 组件属性
import { useComposable } from "./src/composable";
//* 样式
import css from "./style/index.module.less";

//* 组合函数
const { refs, nodes, methods } = useComposable();
const { origin } = refs;
const { init } = methods;
const { body, container, chromosome, attachments } = nodes;

//* 组件属性导出
defineExpose({ init });
</script>
